import { ZERO_ADDRESS } from 'shared/constants';
import Web3 from 'web3';

export const checkIsAddress = (address: string) => {
  return Web3.utils.isAddress(address) && address !== ZERO_ADDRESS;
};
